const About = () => {
  return (
    <section
      data-testid="about-section"
      className="bg-[#FDFCFB] py-24 md:py-32"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <p className="text-xs tracking-[0.35em] uppercase text-[#7B8E76] mb-6">
          Meet Marissa
        </p>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#2D3A2B] leading-tight">
          A Practice Built <span className="italic">Around You</span>.
        </h2>
        <p
          data-testid="about-credentials"
          className="mt-4 text-sm tracking-widest uppercase text-[#7B8E76]"
        >
          Certified Yoga Therapist &nbsp;·&nbsp; Trained in Yoga &amp; Tantric Philosophy
        </p>
        <div className="mt-10 space-y-6 text-[#4A5D46] font-light leading-relaxed">
          <p className="text-lg md:text-xl">
            Every Yoga Therapy practice is created around you—your unique
            physical needs, mental and emotional patterns, nervous system,
            and the way energy flows through your body.
          </p>
          <p className="text-lg md:text-xl">
            My work is grounded in thoughtful assessment, deep listening,
            and an understanding of the science of the nervous system.
            Together, we create a practice that supports your unique goals,
            restores balance, and honours where you are in your journey.
          </p>
          <p
            data-testid="about-location"
            className="text-base pt-8 border-t border-[#E8E5DF] text-[#4A5D46]"
          >
            Based in <span className="text-[#2D3A2B]">Coquitlam</span> and
            serving the <span className="text-[#2D3A2B]">Vancouver Lower
            Mainland</span>, my practice is fully mobile and adaptive —
            shaped to meet a range of environments and people. I&rsquo;m
            also available to travel <span className="text-[#2D3A2B]">
            internationally</span> for private work and retreats.
          </p>
        </div>
        <p className="mt-12 font-serif italic text-xl text-[#7B8E76]">
          — Marissa Rajpaul, Certified Yoga Therapist
        </p>
      </div>
    </section>
  );
};

export default About;
